export const hrcConstants = {
  LIST_HRC_GUIDANCE_REQUEST: "LIST_HRC_GUIDANCE_REQUEST",
  LIST_HRC_GUIDANCE_SUCCESS: "LIST_HRC_GUIDANCE_SUCCESS",
  LIST_HRC_GUIDANCE_FAILURE: "LIST_HRC_GUIDANCE_FAILURE",
  UPDATE_HRC_GUIDANCE_REQUEST: "UPDATE_HRC_GUIDANCE_REQUEST",
  UPDATE_HRC_GUIDANCE_SUCCESS: "UPDATE_HRC_GUIDANCE_SUCCESS",
  UPDATE_HRC_GUIDANCE_FAILURE: "UPDATE_HRC_GUIDANCE_FAILURE",
}
